import { render } from "./ClientTopbar.vue?vue&type=template&id=c96441c6&scoped=true"
import script from "./ClientTopbar.vue?vue&type=script&lang=js"
export * from "./ClientTopbar.vue?vue&type=script&lang=js"

import "./ClientTopbar.vue?vue&type=style&index=0&id=c96441c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c96441c6"]])

export default __exports__